module.exports = __webpack_public_path__ + "img/compu-colores-new.66ed18d4.png";